import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/caikuma_running.png'


const _withScopeId = n => (_pushScopeId("data-v-ac92d9a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cover" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "question-count" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"description\" data-v-ac92d9a0><div class=\"description-title\" data-v-ac92d9a0>CHECK</div> <div class=\"description-content\" data-v-ac92d9a0><p data-v-ac92d9a0>業務開始前に研修を受講してください</p></div> <div class=\"description-image\" data-v-ac92d9a0><img src=\"" + _imports_0 + "\" alt=\"カイクマ\" class=\"caikuma\" data-v-ac92d9a0></div></div>", 1)
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "研修受講時間も勤務時間に含まれます", -1))
const _hoisted_7 = { class: "bottom" }

import { Training } from "@/types/training/Training";
import CautionContainer from "@/components/molecules/CautionContainer.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Cover',
  props: {
  training: {
    type: Object as () => Training,
    required: true
  }
},
  emits: {
  start: () => true
},
  setup(__props, { emit }) {

const props = __props;





function onClickStart() {
  emit("start");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(__props.training.title), 1),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.training.questions.length) + "問", 1)
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createTextVNode(),
      _createVNode(CautionContainer, null, {
        title: _withCtx(() => [
          _createTextVNode("すでに打刻済みです")
        ]),
        content: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(AppButton, {
        onClick: onClickStart,
        class: "next-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode("研修を受講する")
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}
}

})